import React, { useState } from 'react';
import WordWithFurigana from './WordWithFurigana'; // Import the WordWithFurigana component

// Component to handle individual word with furigana

const Titulo = ({ data, ilustrador, verTraduccion, verDesglose, verFurigana, verRomaji, handleClickSegmento, destacado }) => {

    return (
        <div className="mb-8 pb-6 border-b border-sage-200/60 mt-6">
            <div className={`font-bold text-4xl lg:text-5xl text-center mb-4 ${verDesglose ? 'cursor-pointer' : 'cursor-default'} flex flex-wrap justify-center items-center text-primary-800 font-japanese`}>
            
                {data.jp.segments.map((segment, index) => {
                    const segmentId = `titulo_${index}`;
                    const isActive = destacado === segmentId;
                    
                    return (
                        <React.Fragment key={index}>
                            <div 
                                data-segment-id={segmentId}
                                className={`inline-flex items-end whitespace-nowrap transition-all duration-200 ${
                                    verDesglose 
                                        ? `hover:text-japanese-cherry hover:scale-105 hover:drop-shadow-lg ${
                                            isActive ? 'text-japanese-cherry scale-105 drop-shadow-lg' : ''
                                          }` 
                                        : ''
                                } px-1`}
                                onClick={(e) => handleClickSegmento(e, segment.explanation, segmentId, true)}
                            >
                                {segment.words.map((word, indexWord) => (
                                    <WordWithFurigana 
                                        key={indexWord}
                                        word={word}
                                        verFurigana={verFurigana}
                                        verRomaji={verRomaji}
                                        isTitle={true} // Pass isTitle prop to adjust styles
                                    />
                                ))}
                            </div>
                            {verDesglose && index < data.jp.segments.length - 1 && (
                                <span className="text-sage-400 mx-1">　</span>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
            

            
            {verTraduccion && (

                    <p className="text-2xl lg:text-3xl text-primary-700 font-semibold mb-8 text-center italic">
                        {data.es}
                    </p>
            )}

                        {/* Ilustrador credit */}
            <div className="flex items-center justify-center mt-3 mb-4">
                <i className="fa-solid fa-paintbrush w-4 h-4 text-pearl-800 mr-2"></i>
                <span className="text-sm text-pearl-800">
                    Ilustrado por{' '}
                    <a 
                        href={`https://instagram.com/${ilustrador}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-pearl-800 hover:text-japanese-cherry transition-colors underline"
                    >
                        @{ilustrador}
                    </a>
                </span>
            </div>
        </div>

        
    );
};

export default Titulo;
